import { useId, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import type { NodeReport } from '@cortex/cluster-report';
import { Meter } from '../components/Meter';
import { formatBytes, rootDisk } from './cluster-summary';

export function NodeDisks({ node }: { node: NodeReport }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const root = rootDisk(node);
  const other = node.disks?.filter(disk => disk.mountPoint !== '/') ?? [];
  const legacy = node.disks == null ? node.filesystem : null;
  return (
    <div className="space-y-3">
      <Meter
        label="Root disk /"
        used={root?.usedBytes ?? null}
        total={root?.capacityBytes ?? 0}
        format={formatBytes}
        detail={root ? `${formatBytes(root.availableBytes)} free` : 'Host disk metrics unavailable'}
      />
      {(other.length > 0 || legacy) && (
        <div>
          <button
            type="button"
            aria-expanded={open}
            aria-controls={id}
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
          >
            <ChevronRight
              aria-hidden
              className={`h-4 w-4 transition-transform ${open ? 'rotate-90' : ''}`}
            />
            {other.length > 0 ? `Other disks (${other.length})` : 'Kubernetes storage'}
          </button>
          {open && (
            <div id={id} className="mt-3 space-y-4 rounded-3xl border p-4">
              {other.map(disk => (
                <div key={disk.mountPoint} className="space-y-1">
                  <Meter
                    label={disk.mountPoint}
                    used={disk.usedBytes}
                    total={disk.capacityBytes}
                    format={formatBytes}
                    detail={`${formatBytes(disk.availableBytes)} free`}
                  />
                  <p className="break-all text-xs text-muted-foreground">
                    {disk.device} · {disk.filesystemType}
                  </p>
                </div>
              ))}
              {legacy && (
                <Meter
                  label="Kubernetes storage"
                  used={legacy.usedBytes}
                  total={legacy.capacityBytes}
                  format={formatBytes}
                  detail={`${formatBytes(legacy.availableBytes)} free`}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
